import { render, staticRenderFns } from "./FooterSocialOE.vue?vue&type=template&id=ff9188bc&scoped=true"
import script from "./FooterSocialOE.vue?vue&type=script&lang=js"
export * from "./FooterSocialOE.vue?vue&type=script&lang=js"
import style0 from "./FooterSocialOE.vue?vue&type=style&index=0&id=ff9188bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9188bc",
  null
  
)

export default component.exports